export function setMaskMoney(value: string | number): string {
    const digits = String(value ?? "").replace(/\D/g, "");

    if (!digits) {
        return "0,00";
    }

    let formatted = (Number.parseInt(digits, 10) / 100).toFixed(2);
    formatted = formatted.replace(".", ",");
    formatted = formatted.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
    formatted = formatted.replace(/(\d)(\d{3}),/g, "$1.$2,");

    return formatted;
}
